<template>
  <h3 class="pb-4">{{ title }}</h3>
  <Line :data="chartData" :options="chartOptions" />
</template>

<script>
import { Line } from 'vue-chartjs'
import { Chart, registerables } from 'chart.js'
import { computed } from 'vue'
Chart.register(...registerables)

export default {
  name: 'LineChart',
  components: {
    Line,
  },
  props: {
    title: String,
    // X軸のラベル
    x_labels: Array,
    // 凡例のラベル
    hanrei_labels: Array,
    // グラフのデータリスト
    data: Array,
  },
  setup(props) {
    const chartData = computed(() => {
      // データセットを動的に生成
      const dataset_list = [];
      for (let i = 0; i < props.data.length; i++) {
        if (i >= 10) {
          break;  // 最大10個のデータセットを表示 *予備の色がない。
        }
        const temp_dataset = {
          // ツールチップの凡例
          label: props.hanrei_labels[i],
          data: props.data[i],
          borderColor: colorSets[i].borderColor,
          backgroundColor: colorSets[i].backgroundColor,
          fill: false,
          tension: 0.1
        }
        dataset_list.push(temp_dataset);
      }
      // 返り値
      return {
        // labales = X軸のラベル
        labels: props.x_labels,
        datasets: dataset_list,
      }
    })

    const colorSets = [
      {
        backgroundColor: 'rgba(54, 162, 235, 0.2)',   // 青
        borderColor:     'rgba(54, 162, 235, 1)'
      },
      {
        backgroundColor: 'rgba(255, 99, 132, 0.2)',   // 赤
        borderColor:     'rgba(255, 99, 132, 1)'
      },
      {
        backgroundColor: 'rgba(255, 206, 86, 0.2)',   // 黄
        borderColor:     'rgba(255, 206, 86, 1)'
      },
      {
        backgroundColor: 'rgba(75, 192, 192, 0.2)',   // 緑
        borderColor:     'rgba(75, 192, 192, 1)'
      },
      {
        backgroundColor: 'rgba(153, 102, 255, 0.2)',  // 紫
        borderColor:     'rgba(153, 102, 255, 1)'
      },
      {
        backgroundColor: 'rgba(255, 159, 64, 0.2)',   // オレンジ
        borderColor:     'rgba(255, 159, 64, 1)'
      },
      {
        backgroundColor: 'rgba(99, 255, 132, 0.2)',   // 明るい緑
        borderColor:     'rgba(99, 255, 132, 1)'
      },
      {
        backgroundColor: 'rgba(255, 99, 255, 0.2)',   // ピンク
        borderColor:     'rgba(255, 99, 255, 1)'
      },
      {
        backgroundColor: 'rgba(99, 132, 255, 0.2)',   // 水色
        borderColor:     'rgba(99, 132, 255, 1)'
      },
      {
        backgroundColor: 'rgba(200, 200, 200, 0.2)',  // グレー
        borderColor:     'rgba(200, 200, 200, 1)'
      }
    ];
    

    const chartOptions = {
      responsive: true,
      plugins: {
        legend: { display: true },
        tooltip: {
          mode: 'index', // これで同じX軸の全系列を表示
          intersect: false
        }
      }
    }

    return {
      chartData,
      chartOptions
    }
  }
}
</script>